<template src="./CheckoutEmpowerment.html"/>
<style lang="scss" scoped src="./CheckoutEmpowerment.scss"/>

<script>
import CartPreview from '@/components/Checkout/CartPreview';
import PaymentEmpowerment from "@/pages/Checkout/Payment-Empowerment";
import {Client} from "@/models/client";

export default {
    name: 'CheckoutEmpowerment',
    layout: 'checkout',

    components: {
        PaymentEmpowerment,
        CartPreview
    },
    data() {
        return {
            isDone: false,
            sidebar: true,
            client: null,
            giftCard: null
        }
    },

    mounted() {
        try {
            this.client = Client.of(JSON.parse(sessionStorage.getItem('empowermentClient')));
        } catch (e) {
            this.client = null
        }
    },

    computed: {
        currentCart: {
            get() {
                return this.$store.getters.getCart
            },
        },
        isThankYou: {
            get() {
                return this.$route.name === 'CheckoutThankYou';
            }
        },
    }, watch: {
        currentCart(newCart, oldCart) {
            if (!newCart && !oldCart) {
                this.$router.push(this.$localizePath('/mon-panier')).catch();
            }
        }
    },
    methods: {
        isDoneShipping(e) {
            this.isDone = e
        },
        setGiftCard(card) {
            this.giftCard = card
        }
    }
};
</script>